import { market, sgoBillImageUrl } from '../../constants';
import { APP_SETTINGS } from '../../settings/AppSettings';

const { PERU, CHILE } = APP_SETTINGS.COUNTRIES;
const zFillWithZeros = (text, width) => '0'.repeat(width - text.length) + text;

const billImageUrl = (orderId) =>
  `${sgoBillImageUrl}=${zFillWithZeros(orderId.toString(), 16)}0000&order=OK`;

export const defineBillImageByCountry = (billImage, orderId, source) => {
  switch (market) {
    case PERU.SHORT_NAME:
      return billImage;
    case CHILE.SHORT_NAME:
      return source === 'MTO' ? billImage : billImageUrl(orderId);
    default:
      return '';
  }
};

export const showOrdersInformativeAlert = () => market === PERU.SHORT_NAME;
